export enum KEY {
  REF = "Ref",
  SCHEDULE_GROUP_ID = "scheduleGroupID",
  SALES_ORDER_QUANTITY = "salesOrderQuantity",
  TOTAL_AMOUNT_LITERS = "totalAmountLiters",
  SCHEDULE_ID = "scheduleID",
  CUSTOMER = "customer",
  PRODUCT = "product",
  QUANTITY = "quantity",
  CNPJ = "cnpj",
  DELIVERY_DATE = "deliveryDate", // Data de Entrega
  RELEASE_DATE = "releaseDate", // Data de Liberação
  INVOICE_DATE = "invoiceDate", // Data de Faturamento
  BLOCKED_DATE = "blockedDate", // Data de Bloqueio
  TRUCK_DRIVER = "truckDriver",
  PLATE = "plate",
  FILIAL = "filial",
  FILIAL_NAME = "filialName",
  ORDER = "order",
  SCHEDULE_DATE = "scheduleDate",
  STATUS = "status",
  ACTION = "action",
  ACTION_CHECK = "actionCheck",
  FREIGHT = "freight",
  BPID = "bpId",
  ICON = "icon",
  DRIVER = "truckDriver",
  REASON_CANCELLATION = "reasonCancellation",
  DESCRIPTION_CANCELLATION = "descriptionCancellation",
  SALES_ORDER = "salesOrder",
  RESCHEDULABLE = "reschedulable",
  STATUS_PROGRAMATION = "Status_Programacao",
  COMPARTIMENTS = "compartiments",
  CUSTOMER_ID = "customerID",
  BP_ID_NAME = "bpIdName",
  TIMEZONE = "timezone",
}

export enum STATUSTYPE {
  FT = "FT",
  BL = "BL",
  LIB = "LIB",
  PENDING = "PENDING",
  FINISHED = "FINISHED",

  FATURADO = "Faturado",
  BLOQUEADO = "Bloqueado",
  LIBERADO = "Liberado",
  CANCELADO = "Cancelado",
}

export enum STATUSROADLOAD {
  SCHEDULED = "SCHEDULED",
  WAITING = "WAITING_SCHEDULE",
  FINISHED = "FINISHED",
  BLOCKED = "BLOCKED",
  CANCELED = "CANCELED",
  UPCOMING_SCHEDULE = "UPCOMING_SCHEDULE",
}

export enum FileType {
  PDF = "pdf",
  XML = "xml",
}

export enum User {
  USER_NAME = "nameLogin",
  SIDEBAR_ADMIN = "sidebarAdmin",
}

export enum UserType {
  Transportadora = "Transportadora",
  Motorista = "Motorista",
  Cliente = "Cliente",
}
